import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { SafeHtmlModule } from '../../../pipes/safe-html.module';
import { FeedbackMessageComponent } from '../../feedback-message/feedback-message.component';
import { IconModule } from '../../icon/icon.module';
import { TooltipModule } from '../../tooltip/tooltip.module';
import { DotIndicatorModule } from '../../dotindicator/dotindicator.module';
import { InputContainerComponent } from './input-container.component';

@NgModule({
  declarations: [InputContainerComponent],
  imports: [
    CommonModule,
    FeedbackMessageComponent,
    IconModule,
    TooltipModule,
    TranslocoModule,
    SafeHtmlModule,
    DotIndicatorModule,
  ],
  exports: [InputContainerComponent],
})
export class InputContainerModule {}
